import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CalendarTally = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 6H22V5C22 4.448 21.552 4 21 4C20.448 4 20 4.448 20 5V6H12V5C12 4.448 11.552 4 11 4C10.448 4 10 4.448 10 5V6H9C6.243 6 4 8.243 4 11V23C4 25.757 6.243 28 9 28H23C25.757 28 28 25.757 28 23V11C28 8.243 25.757 6 23 6ZM26 23C26 24.654 24.654 26 23 26H9C7.346 26 6 24.654 6 23V11C6 9.346 7.346 8 9 8H10V9C10 9.552 10.448 10 11 10C11.552 10 12 9.552 12 9V8H20V9C20 9.552 20.448 10 21 10C21.552 10 22 9.552 22 9V8H23C24.654 8 26 9.346 26 11V23Z" />
		<path d="M23 14C22.907 14 22.818 14.014 22.733 14.037C22.732 14.037 21.609 14.358 20 14.818V13C20 12.448 19.552 12 19 12C18.448 12 18 12.448 18 13V15.389C16.714 15.756 15.314 16.156 14 16.532V13C14 12.448 13.552 12 13 12C12.448 12 12 12.448 12 13V17.103C10.104 17.645 8.721 18.04 8.721 18.04C8.305 18.161 8 18.544 8 19C8 19.552 8.448 20 9 20C9.095 20 9.186 19.986 9.273 19.961C9.273 19.961 10.393 19.641 12 19.182V21C12 21.552 12.448 22 13 22C13.552 22 14 21.552 14 21V18.611C15.286 18.244 16.686 17.844 18 17.468V21C18 21.552 18.448 22 19 22C19.552 22 20 21.552 20 21V16.897C21.896 16.355 23.279 15.96 23.279 15.96C23.695 15.839 24 15.456 24 15C24 14.448 23.552 14 23 14V14Z" />
	</svg>
);

export default CalendarTally;
